import React, { FC, ReactElement, ChangeEvent, MouseEvent } from 'react';
import classNames from 'classnames/bind';

import { IQuestion } from 'sections/Feedback/EventsSurvey/types';

import RadioButton from 'ui/RadioButton';
import Checkbox from 'ui/Checkbox';
import { Input } from 'sections/Feedback/EventsSurvey/components/Input';

import styles from 'sections/Feedback/EventsSurvey/components/QuestionItem/QuestionItem.module.scss';

const cn = classNames.bind(styles);

interface QuestionsItemProps {
  question: IQuestion;
  setFormData(state: any): void;
  onChangeHandler(event: ChangeEvent<HTMLInputElement>, type: string, id: number, survey_id: number): void;
  onBlurHandler(id: number, value: string): void;
  formData: { id: number; value: string | boolean }[];
  errorsAnswer: { question_id: number; value: string; id: number }[];
};

const QuestionItem: FC<QuestionsItemProps> = ({
  formData,
  onChangeHandler,
  onBlurHandler,
  question,
  errorsAnswer,
}): ReactElement => {
  const tooltipHide = () => {
    const tooltipElement: any = document.querySelector(`.${cn('question-item__tooltip')}`);

    tooltipElement?.remove();
  };

  const tooltipShow = (event: MouseEvent, description: string) => {
    const boxElement: any = event.currentTarget.parentElement;

    const tooltipElement: any = document.createElement('div');
    tooltipElement.classList.add(cn('question-item__tooltip'));
    tooltipElement.innerText = description;

    boxElement.append(tooltipElement);

    setTimeout(() => {
      tooltipElement.style.opacity = 1;
    }, 300);
  };

  const createElement = question.options.map((option) => {
    const currentOption = formData.filter((item) => {
      return item.id === option.id;
    });

    const currentError = errorsAnswer.filter((item: any) => {
      return item.id === option.id;
    });

    if (!question.multiple && option.option_type === 'variant') {
      return (
        <RadioButton
          key={option.id}
          id={option.id}
          name={`${option.id}`}
          value={option.title}
          label={option.title}
          elementType={option.option_type}
          isChecked={!!currentOption[0]?.value}
          //@ts-ignore
          question_id={question.id}
          formErrors={currentError[0]?.value === '' ? 'some error' : ''}
          //@ts-ignore
          action={onChangeHandler}
          errors={currentError[0]?.value === '' || false}
        // stylePreset="bordered"
        />
      );
    } else if (question.multiple && option.option_type === 'variant') {
      return (
        <Checkbox
          key={option.id}
          id={option.id}
          name={`${option.id}`}
          value={option.title}
          label={option.title}
          elementType={'text'}
          isChecked={Boolean(currentOption[0]?.value)}
          formErrors={currentError[0]?.value === '' ? 'some error' : ''}
          question_id={+question.id}
          // withTooltip={option.description}
          // description={option.description}
          //@ts-ignore
          action={onChangeHandler}
          // stylePreset="bordered"
          errors={currentError[0]?.value === '' || false}
        />
      );
    } else if (option.option_type === 'input' || option.option_type === 'text') {
      return (
        <div className={cn('question-item__answer-input-container')} key={option.id}>
          {option.title === 'null'
            ?
            <></>
            :
            <span className={cn('question-item__answer-text')}>{option.title}</span>
          }
          <Input
            key={option.id}
            id={option.id}
            name={`${option.id}`}
            action={onBlurHandler}
            errors={currentError[0]?.value === '' || false}
          />
        </div>
      );
    }
  });

  return (
    <div className={cn('question-item')}>
      <div className={cn('question-item__heading-container')}>
        <h3 className={cn('question-item__heading')}>
          {question.title}
        </h3>
        {question.description && (
          <div className={cn('question-item__tooltip-container')}>
            <svg
              onMouseOver={(event) => tooltipShow(event, question.description)}
              onMouseOut={tooltipHide}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M511.1 63.1v287.1c0 35.25-28.75 63.1-64 63.1h-144l-124.9 93.68c-7.875 5.75-19.12 .0497-19.12-9.7v-83.98h-96c-35.25 0-64-28.75-64-63.1V63.1c0-35.25 28.75-63.1 64-63.1h384C483.2 0 511.1 28.75 511.1 63.1z" />
            </svg>
          </div>
        )}
      </div>
      <div className={cn('question-item__answer-container')}>
        {createElement}
      </div>
    </div>
  );
};

export { QuestionItem };
